import api from '../store/apiClient';

export async function getFaqs(params = {}) {
  const { data } = await api.get('/faqs', { params });
  const list = data?.data;
  return Array.isArray(list) ? list : [];
}
